"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachColumnTypes = void 0;
const GeneralConstants_1 = require("../Utilities/Constants/GeneralConstants");
const attachColumnTypes = (gridOptions) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    gridOptions.columnTypes = (_a = gridOptions.columnTypes) !== null && _a !== void 0 ? _a : {};
    return Object.assign(gridOptions.columnTypes, {
        [GeneralConstants_1.AB_SPECIAL_COLUMN]: {},
        [GeneralConstants_1.AB_FDC3_COLUMN]: {},
        abColDefNumber: (_b = gridOptions.columnTypes.abColDefNumber) !== null && _b !== void 0 ? _b : {},
        abColDefString: (_c = gridOptions.columnTypes.abColDefString) !== null && _c !== void 0 ? _c : {},
        abColDefBoolean: (_d = gridOptions.columnTypes.abColDefBoolean) !== null && _d !== void 0 ? _d : {},
        abColDefDate: (_e = gridOptions.columnTypes.abColDefDate) !== null && _e !== void 0 ? _e : {},
        abColDefObject: (_f = gridOptions.columnTypes.abColDefObject) !== null && _f !== void 0 ? _f : {},
        abColDefCustom: (_g = gridOptions.columnTypes.abColDefCustom) !== null && _g !== void 0 ? _g : {},
        abColDefStringArray: (_h = gridOptions.columnTypes.abColDefStringArray) !== null && _h !== void 0 ? _h : {},
        abColDefNumberArray: (_j = gridOptions.columnTypes.abColDefNumberArray) !== null && _j !== void 0 ? _j : {},
        abColDefTupleNumberArray: (_k = gridOptions.columnTypes.abColDefTupleNumberArray) !== null && _k !== void 0 ? _k : {},
        abColDefObjectNumberArray: (_l = gridOptions.columnTypes.abColDefObjectNumberArray) !== null && _l !== void 0 ? _l : {},
    });
};
exports.attachColumnTypes = attachColumnTypes;
